import { AxiosResponse } from 'axios';
import axios from '|/helpers/axios';
import { PURCHASE_FUNDING_ENDPOINTS } from './endpoints';
import {
  ApprovedLenderOptionsResponse,
  CoApplicantToggleUpdateResponse,
  CoSignerEligibility,
  DownRecircAPIResponse,
  IdentityPayload,
  IdentityResponse,
  Options,
  PaymentOptionsFinanceTerms,
  PaymentOptionsResponse,
  SelfArrangedFinanceLoanInput,
  Term,
  ThirdPartyLoanDetailsResponse
} from './types';

export const getThirdPartyLoanDetails = (abortSignal: AbortSignal) =>
  axios
    .get<ThirdPartyLoanDetailsResponse>(PURCHASE_FUNDING_ENDPOINTS.THIRD_PARTY_LOAN_DETAILS, {
      signal: abortSignal
    })
    .then(res => res.data);

export const saveThirdPartyLoanDetails = (
  payload: SelfArrangedFinanceLoanInput,
  abortSignal: AbortSignal
) =>
  axios
    .post<unknown>(
      PURCHASE_FUNDING_ENDPOINTS.THIRD_PARTY_LOAN_DETAILS,
      {
        ...payload
      },
      {
        signal: abortSignal
      }
    )
    .then(res => res.data);

export const getApprovedLenderOptions = (abortSignal: AbortSignal) =>
  axios
    .get<ApprovedLenderOptionsResponse[]>(PURCHASE_FUNDING_ENDPOINTS.GET_APPROVED_LENDER_OPTIONS, {
      signal: abortSignal
    })
    .then(res => res.data);

export const getDownRecirculation = (abortSignal: AbortSignal, excludeWip: boolean = false) =>
  axios
    .get<DownRecircAPIResponse>(PURCHASE_FUNDING_ENDPOINTS.GET_DOWN_RECIRCULATION, {
      signal: abortSignal,
      params: excludeWip ? { excludeWip: true } : undefined
    })
    .then(res => res.data);

export const getPaymentOptions = (abortSignal: AbortSignal) =>
  axios
    .get<PaymentOptionsResponse>(PURCHASE_FUNDING_ENDPOINTS.PAYMENT_OPTIONS, {
      signal: abortSignal
    })
    .then(res => res.data);

export const submitPaymentOption = (payload: Options, abortSignal: AbortSignal) =>
  axios.post(
    PURCHASE_FUNDING_ENDPOINTS.PAYMENT_OPTIONS,
    {
      type: payload.type,
      institutionName: payload.institutionName
    },
    {
      signal: abortSignal
    }
  );

export const getTerms = (abortSignal: AbortSignal) =>
  axios
    .get<PaymentOptionsFinanceTerms>(PURCHASE_FUNDING_ENDPOINTS.PAYMENT_TERMS, {
      signal: abortSignal
    })
    .then(res => res.data);

export const selectTerms = (payload: Term, abortSignal: AbortSignal) =>
  axios.post(PURCHASE_FUNDING_ENDPOINTS.PAYMENT_TERMS, payload, {
    signal: abortSignal
  });

export const getCoApplicantEligibility = (abortSignal: AbortSignal) =>
  axios
    .get<CoSignerEligibility>(PURCHASE_FUNDING_ENDPOINTS.COAPPLICANT_ELIGIBILITY, {
      signal: abortSignal
    })
    .then(res => res.data);

export const toggleCoApplicant = (abortSignal: AbortSignal) =>
  axios
    .post<never, AxiosResponse<CoApplicantToggleUpdateResponse>>(
      PURCHASE_FUNDING_ENDPOINTS.TOGGLE_COAPPLICANT,
      undefined,
      {
        signal: abortSignal
      }
    )
    .then(res => res.data);

export const getIdentity = (signal?: AbortSignal): Promise<IdentityResponse> =>
  axios
    .get<IdentityResponse>(PURCHASE_FUNDING_ENDPOINTS.IDENTITY, {
      signal
    })
    .then(res => res.data);

export const submitIdentityDetails = (
  payload: IdentityPayload,
  signal?: AbortSignal
): Promise<IdentityResponse> =>
  axios
    .post<IdentityResponse>(PURCHASE_FUNDING_ENDPOINTS.IDENTITY, payload, {
      headers: {
        'Content-Type': 'application/json'
      },
      signal
    })
    .then(res => res.data);
